export const bytesToMegabytes = (bytes) => bytes / (1024 * 1024);

const isValidZoom = (zoom) =>
  typeof zoom === 'number' && !isNaN(zoom) && zoom >= 1 && zoom <= 3;

export const getZoom = (zoom) => (isValidZoom(zoom) ? zoom : 1);

const isPositiveNum = (value) => typeof value === 'number' && value >= 0;

export const getCroppedArea = (croppedArea) => {
  const { x, y, width, height } = croppedArea || {};

  const data = { x, y, width, height };

  return Object.values(data).some((value) => !isPositiveNum(value))
    ? null
    : data;
};

export const formatZoom = (zoom) =>
  Number.isInteger(zoom) ? zoom : zoom.toFixed(1).replace('.', ',');

export const getExtensionFromFileName = (fileName) => {
  if (!fileName) return '';

  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop() : '';
};
